export default __webpack_public_path__ + "static/ourErviceImg-eaea2ab5c010ce126a156ebb1de7c73a.jpg";